<template>
  <v-card 
    id="card-module-menu"
    rounded="sm"
    :elevation="0"
  >
    <v-card-text
      class="d-flex justify-content-between"
      :class="{
        'py-2 px-2' : isMobile
      }"
    >
      <v-btn
        color="nitro"
        outlined
        :small="isMobile"
        :to="{ name: studyNowRouteName }"
      >
        <span class="first-letter-capitalize">
          Voltar para o Estude agora
        </span>
      </v-btn>
      <VideoCastButton v-if="module.type == 'theme'" />
      <EbookButton v-else />
    </v-card-text>
    <v-card-title class="py-1 px-0">
      <v-container v-if="module">
        <v-row>
          <v-col
            cols="12"
            order="1"
            order-md="1"
            order-sm="1"
            :class="{ 'p-0' : isMobile }"
          >
            <v-card
              class="bg-custom-light-blue "
              :rounded="isMobile ? '0' : 'sm'"
              outlined
              :style="{
                'border-radius': isMobile ? '0!important' : false,
              }"
            >
              <v-card-text class="text-black font-weight-semibold py-2 py-md-4 mx-2">
                <img 
                  width="32px"
                  height="32px"
                  src="/images/icons/module_blue_icon.svg"
                  class="mr-1"
                  :class="{
                    'ml-n2' : isMobile,
                  }"
                >
                <span
                  v-if="module.type == 'default'"
                > 
                  {{ module.subject_acronym }} |
                </span> 
                {{ module.type != 'theme' ? module.subject_name : module.block.name }}  
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            class="p-2"
            :class="{
              'px-0': isMobile,
            }"
            order="2"
            order-sm="2"
            order-md="2"
          >
            <h5 class="text-break mx-md-6 mb-0 d-flex align-items-center">
              <div 
                class="position-relative mr-2"
                :class="{
                  'ml-2' : isMobile
                }"
              > 
                <img
                  src="/images/icons/file_icon.svg"
                  alt="ciclo"
                  width="32"
                  height="32"
                >
                <span
                  class="position-absolute theme--text font-weight-bold font-10"
                  style="bottom: -3px; left: 3px;"
                >
                  {{ module.module_order }}
                </span>
              </div>
              <span class="font-weight-bold font-16 mt-2"> {{ module.name }}</span>
            </h5>
          </v-col>
          <v-col 
            ref="progress-column"
            cols="12"
            class="py-2 "
            :class="{
              'px-0': $vuetify.breakpoint.mobile,
            }"
            order="3"
          >
            <v-divider
              :class="{
                'mb-4': !isMobile,
              }"
            />
            <h6
              class="mb-0 ml-1 font-weight-bold d-flex align-items-center"
              :class="{
                'm-0 py-2 ml-2': isMobile
              }"
            >
              <span class="text-uppercase">
                progresso no módulo:
              </span>
              <span class="purple--text">
                {{ module.count_completed_contents }}/{{ module.count_contents }}
              </span>
              <span class="font-weight-semibold purple--text">
                <strong>
                  ({{ Math.round(module.module_progress) }}%)
                </strong>
              </span>
            </h6>
            <v-divider
              v-if="!isMobile"
              class="mt-4"
            />
          </v-col>
          <v-col
            v-if="$vuetify.breakpoint.mobile"
            class="p-md-4 mb-md-2 primary white--text d-flex align-items-center"
            cols="12"
            order="last"
          >
            <img
              :src="`/images/${videocast_selected ? 'video' : content.type }_content_icon.svg`"
              width="32"
              height="32"
              class="inverted"
            > 
            <span
              v-if="videocast_selected"
              class="ml-1 text-break"
              :class="{
                'font-12' : isMobile
              }"
            >
              {{ module.video.title }}
            </span>
            <span
              v-else
              class="ml-1 text-break"
              :class="{
                'font-12' : isMobile
              }"
            >
              {{ content.order + 1 }}. {{ content.title }}
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text
      v-show="!$vuetify.breakpoint.mobile"
    >
      <ModuleContentMenu v-if="module" />
    </v-card-text>
  </v-card>
</template>

<script>
import { studyNowRouteName } from '@/student/constants/routes'
import ModuleContentMenu from './ModuleContentMenu.vue';
import { mapGetters } from 'vuex';
import EbookButton from "./EbookButton.vue"
import VideoCastButton from "./VideocastButton.vue"

export default {
  components: {
    ModuleContentMenu,
    EbookButton,
    VideoCastButton,  
  },
  data() {
    return {
      studyNowRouteName,
    }
  },
  computed: {
    ...mapGetters(['module','selectedCycle','content','videocast_selected']),
  },
}
</script>
